export const isDark = () => document.documentElement.dataset.theme === "dark"

export const brl = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

// Short currency labels for axes: R$ 250 mil / R$ 1,2 mi. Use brl for full precision.
export const compactBRL = (reais) => {
  const abs = Math.abs(reais)
  if (abs >= 1_000_000) return `R$ ${(reais / 1_000_000).toFixed(1).replace('.', ',')} mi`
  if (abs >= 1_000) return `R$ ${Math.round(reais / 1_000)} mil`
  return brl.format(reais)
}

export const numberToMonthAbbr = {
  1: "Jan",
  2: "Fev",
  3: "Mar",
  4: "Abr",
  5: "Mai",
  6: "Jun",
  7: "Jul",
  8: "Ago",
  9: "Set",
  10: "Out",
  11: "Nov",
  12: "Dez",
}

export const numberToMonth = {
  1: "Janeiro",
  2: "Fevereiro",
  3: "Março",
  4: "Abril",
  5: "Maio",
  6: "Junho",
  7: "Julho",
  8: "Agosto",
  9: "Setembro",
  10: "Outubro",
  11: "Novembro",
  12: "Dezembro",
}

export const monthAbbrToFull = {
  JAN: 'Janeiro',
  FEV: 'Fevereiro',
  MAR: 'Março',
  ABR: 'Abril',
  MAI: 'Maio',
  JUN: 'Junho',
  JUL: 'Julho',
  AGO: 'Agosto',
  SET: 'Setembro',
  OUT: 'Outubro',
  NOV: 'Novembro',
  DEZ: 'Dezembro',
  jan: 'Janeiro',
  fev: 'Fevereiro',
  mar: 'Março',
  abr: 'Abril',
  mai: 'Maio',
  jun: 'Junho',
  jul: 'Julho',
  ago: 'Agosto',
  set: 'Setembro',
  out: 'Outubro',
  nov: 'Novembro',
  dez: 'Dezembro',
}

export const monthFullToAbbr = {
  Janeiro: 'JAN',
  Fevereiro: 'FEV',
  Março: 'MAR',
  Abril: 'ABR',
  Maio: 'MAI',
  Junho: 'JUN',
  Julho: 'JUL',
  Agosto: 'AGO',
  Setembro: 'SET',
  Outubro: 'OUT',
  Novembro: 'NOV',
  Dezembro: 'DEZ',
  janeiro: 'JAN',
  fevereiro: 'FEV',
  março: 'MAR',
  abril: 'ABR',
  maio: 'MAI',
  junho: 'JUN',
  julho: 'JUL',
  agosto: 'AGO',
  setembro: 'SET',
  outubro: 'OUT',
  novembro: 'NOV',
  dezembro: 'DEZ',
} 